"use client";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function SettlementModals({ 
  children, 
  type 
}: { 
  children: React.ReactNode; 
  type: "account" | "logic" 
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        {type === "account" ? (
          <>
            <DialogHeader>
              <DialogTitle>Change Destination Account</DialogTitle>
              <DialogDescription>
                Update the bank account where your settlements are paid into.
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <div className="space-y-2">
                <Label>Bank</Label>
                <select className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
                  <option>Zenith Bank</option>
                  <option>GTBank</option>
                </select>
              </div>
              <div className="space-y-2">
                <Label>Account Number</Label>
                <Input placeholder="Enter new account number" />
              </div>
              <Button className="w-full mt-2">Update Account</Button>
            </div>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Update Settlement Logic</DialogTitle>
              <DialogDescription>
                Adjust your payout conditions and rules.
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <div className="space-y-2">
                <Label>Minimum Settlement Amount</Label>
                <Input type="number" defaultValue="1000" />
              </div>
              <div className="space-y-2">
                <Label>Settlement Schedule</Label>
                <select className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
                  <option>T+1 (Next Day)</option>
                  <option>T+0 (Same Day)</option>
                  <option>Weekly</option>
                </select>
              </div>
              <Button className="w-full mt-2">Save Preferences</Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
